<div class="container-payment-methods">
  <div class="payment-row">
    <p>Formas de pagamento</p>
    <div class="payment-brands">
      <ng-container *ngFor="let image of paymentMethodsImages">
        <img src="/assets/images/payment-methods/{{ image }}" />
      </ng-container>
    </div>
  </div>
</div>